import React, {Component} from "react";
import CourseFinder from "../courseFinder";


class CourseFiltering extends Component {

    render(){
        return (
            <CourseFinder isComponent={true} />
        )
    }
}

export default CourseFiltering;